import { gql } from '@/utilities/gql';
import { makeGqlMutation } from '@/utilities/gqlQuery';

const MUTATION = gql(`
  mutation NarrativeSelectValuationOption($input: SetValuationOptionInput!) {
    selectValuationOption(input: $input) {
      id
    }
  }
`);

export const useNarrativeSelectValuationOptionBase = makeGqlMutation(MUTATION);
export const useNarrativeSelectValuationOption = () => {
  return useNarrativeSelectValuationOptionBase({
    throwOnError: false,
  });
};
